// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:11:44.414Z
// Property: Atrium Court (ID: 6767906449167135)
// Collections: 37 amenities, 3 floorplans (live), 23 photos, 43 POIs, 4 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167135",
  "property_external_id": "1125082",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/atrium-court/5YXq7r/",
  "property_apartments_url": "https://www.apartments.com/atrium-court-phoenix-az/slz9k54/",
  "property_google_business_url": "https://www.google.com/maps/place/Atrium+Court/data=!4m2!3m1!1s0x0:0x8301221b9e5c7231?sa=X&ved=2ahUKEwjmxpX40IOTAxWeNNAFHYMDHwIQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47723982652",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "atrium-court",
  "property_name": "Atrium Court",
  "property_website_url": "https://www.atriumcourtapartmenthomes.com",
  "property_domain": "https://www.atriumcourtapartmenthomes.com",
  "property_address": "2323 W Dunlap Ave",
  "property_full_address": "2323 W Dunlap Ave, Phoenix, AZ 85021",
  "property_address_1": "2323 W Dunlap Ave",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85021",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "North Mountain Village",
  "property_address_latitude": "33.5666543",
  "property_address_longitude": "-112.1102",
  "property_email": "atriumcourt@weidner.com",
  "property_phone": "9283072391",
  "property_call_tracking_phone": "520-265-8013",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Atrium Court in vibrant Phoenix, AZ, where comfort meets style! Choose from our spacious one or two-bedroom floor plans, featuring modern amenities like resort-style pools, a fitness center, and pet-friendly spaces. Immerse yourself in lush landscaping and enjoy easy access to I-17. Your perfect home awaits!",
  "property_long_description": "Welcome to Atrium Court, your ideal apartment community nestled in the vibrant heart of Phoenix, AZ! Experience the perfect blend of comfort and convenience with our thoughtfully designed floor plans, featuring spacious one and two-bedroom options to suit your lifestyle. Our community is brimming with exceptional amenities, including high-speed Wi-Fi, a state-of-the-art fitness center, resort-style pools, and a relaxing spa. Enjoy sunny days in our picnic area with grilling stations, or take a leisurely stroll along our beautifully landscaped walking and biking trails.\n\nAt Atrium Court, we understand that your pet is part of the family, which is why we offer dog and cat friendly apartments that include mature landscaping and a pet-friendly atmosphere. Our friendly, bilingual leasing team is always available to assist you and ensure your living experience is seamless, from online service requests to 24-hour emergency maintenance.\n\nInside your new apartment, you'll find upgraded finishes, wood-like flooring, and well-equipped kitchens featuring a complete appliance package, including a dishwasher, microwave, and in select homes, a washer and dryer for added convenience. Enjoy spacious living with walk-in closets, balconies, and patios perfect for enjoying Arizona's stunning sunsets.\n\nWith easy access to the I-17 freeway and light rail, commuting has never been easier. Experience the welcoming vibe of our smoke-free community where you can relax and unwind with friends, both two-legged and four! \n\nFind your new home at Atrium Court today – browse our availability or schedule a tour to visit our exceptional community! Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-11d3-727b-94cd-67ad866ab1b8.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and umbrellas.",
    "public_id": "019d270f-11d3-727b-94cd-67ad866ab1b8",
    "storage_key": "property/6767906449167135/019d270f-11d3-727b-94cd-67ad866ab1b8.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "192",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": "57",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.83333333333334",
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": "500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per unit. Non‑refundable pet fee: $200 per pet. Refundable pet deposit: $200 per pet. Monthly pet rent: $25 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://atriumcourtapartmenthomes.securecafe.com/onlineleasing/atrium-court/floorplans.aspx",
  "property_resident_portal_url": "https://atriumcourtapartmenthomes.securecafenet.com/residentservices/atrium-court/userlogin",
  "property_apply_now_url": "https://atriumcourtapartmenthomes.securecafe.com/onlineleasing/atrium-court/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-1968-76cc-96e5-a42d11bc88f7.webp",
  "property_primary_logo_media": {
    "alt_text": "Atrium Court Apartment Homes logo",
    "public_id": "019d270f-1968-76cc-96e5-a42d11bc88f7",
    "storage_key": "property/6767906449167135/019d270f-1968-76cc-96e5-a42d11bc88f7.webp",
    "width": 125,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-22a1-7339-92f2-1f5b8d663869.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Atrium Court Apartment Homes logo",
    "public_id": "019d270f-22a1-7339-92f2-1f5b8d663869",
    "storage_key": "property/6767906449167135/019d270f-22a1-7339-92f2-1f5b8d663869.webp",
    "width": 125,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-2896-731d-b526-9a58e0793967.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Atrium Court Apartment Homes logo",
    "public_id": "019d270f-2896-731d-b526-9a58e0793967",
    "storage_key": "property/6767906449167135/019d270f-2896-731d-b526-9a58e0793967.webp",
    "width": 125,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#e66f4a",
  "property_secondary_color": "#e8e8c7",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#3e3b35",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 912",
  "property_sqft_min": "664",
  "property_sqft_max": "912",
  "property_price_range": "1175 - 2250",
  "property_price_min": "1175",
  "property_price_max": "2250",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/AtriumCourtApartments",
  "property_instagram_url": "https://www.instagram.com/atriumcourtapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ24JJWVhsK4cRMXJcnhsiAYM",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Atrium Court",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Atrium Court in sunny Phoenix, AZ, where modern living meets comfort. Our thoughtfully designed one and two-bedroom apartments offer upscale amenities, including resort-style pools, state-of-the-art fitness centers, and inviting picnic areas. Enjoy a pet-friendly vibe, Wi-Fi lounges, and a dedicated leasing team ready to assist you!",
  "property_home_floorplans_blurb": "At Atrium Court in vibrant Phoenix, AZ, your ideal apartment home awaits. With diverse floor plans tailored to fit your lifestyle, each space boasts modern comforts and inviting designs. Dive into a world of convenience and style—browse our available apartments and start crafting your perfect living experience today!",
  "property_home_gallery_blurb": "At Atrium Court in Phoenix, AZ, every detail is designed for comfort and convenience. Choose from one or two-bedroom floor plans featuring modern amenities, relaxing pool areas, and scenic walking trails. With a friendly leasing team and lush, mature landscaping, your ideal living experience awaits—picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Phoenix, Atrium Court offers spacious one and two-bedroom floor plans, perfect for your lifestyle. Just steps away, top-rated schools like Washington Elementary and Cortez High ensure a bright future for families. Embrace community living while enjoying nearby parks and local attractions—your ideal home awaits!",
  "property_home_reviews_blurb": "At Atrium Court in sunny Phoenix, AZ, residents rave about the vibrant community vibes, stating, \"The staff is friendly, and the amenities exceed expectations!\" Experience a warm, welcoming atmosphere that makes every day feel special. Dive into our residents' stories to see what truly sets us apart!",
  "property_neighborhood_blurb": "At Atrium Court in Phoenix, AZ, your home is surrounded by an enriching community. With quality schools like Washington Elementary and Royal Palm Middle nearby, your family will thrive. Experience a vibrant lifestyle where education and recreation blend seamlessly. See what's around our community and uncover local favorites and nearby points of interest.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Atrium Court in Phoenix, AZ, elevate your lifestyle surrounded by lush landscapes and modern comforts. Enjoy resort-style pools, a state-of-the-art fitness center, and pet-friendly spaces. With upgraded one and two-bedroom floor plans and an inviting lounge, every detail is designed for easy living. Experience home like never before!",
  "property_applynow_blurb": "Nestled in the heart of Phoenix, Atrium Court offers a vibrant blend of comfort and convenience. With spacious one and two-bedroom floor plans, indulge in resort-style amenities like a refreshing pool, fitness center, and dog-friendly picnic area. Experience modern living—apply online today and make Atrium Court your new sanctuary!",
  "property_contactus_blurb": "At Atrium Court in vibrant Phoenix, AZ, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience the perfect blend of modern comfort and convenience. Have questions? Reach out to our friendly leasing team today to find your ideal home at Atrium Court!",
  "property_faqs_blurb": "At Atrium Court in vibrant Phoenix, AZ, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Have questions? Our FAQs page is your go-to resource for everything you need to know about our community. Dive in and get the insights you seek!",
  "property_floorplans_blurb": "At Atrium Court in sunny Phoenix, AZ, we offer thoughtfully designed one- and two-bedroom apartment homes that cater to your lifestyle. Unveil the perfect space tailored to your needs—your ideal floor plan awaits. Browse our options today and embrace the vibrant community living experience that awaits you!",
  "property_gallery_blurb": "At Atrium Court in Phoenix, AZ, vibrant living awaits. Choose from stylish one or two-bedroom floor plans, each boasting modern amenities and lush landscapes. Unwind by the resort-style pool, enjoy our scenic picnic area, and let your fur babies thrive in our pet-friendly environment. Picture yourself living here!",
  "property_interactivemap_blurb": "At Atrium Court in Phoenix, AZ, enjoy luxurious living with spacious one and two-bedroom floor plans, resort-style amenities, and a vibrant community vibe. From our lush picnic area and serene walking trails to the sparkling pool and modern fitness center, every detail is designed for your comfort. Dive into our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to Atrium Court, where vibrant living meets pet-friendly policies in the heart of Phoenix, AZ. With space for two furry companions, a $200 fee, and a nurturing community, your pets will thrive as much as you do in our charming lifestyle haven. Experience the perfect blend of comfort and companionship!",
  "property_referafriend_blurb": "At Atrium Court in sunny Phoenix, AZ, your dream apartment awaits! With spacious one and two-bedroom layouts tailored for modern living, you and your friends can find the perfect home together. After all, great friends make great neighbors—refer a friend to our vibrant community today!",
  "property_residentaccess_blurb": "Welcome to Atrium Court in sunny Phoenix, AZ, where your perfect home awaits. Choose from spacious one or two-bedroom floor plans tailored to your lifestyle. Need to handle rent or maintenance? Access your resident portal easily—your convenience is our priority! Embrace modern living in a vibrant community today!",
  "property_reviews_blurb": "At Atrium Court in Phoenix, AZ, residents rave about the vibrant community atmosphere, noting it's \"a place where neighbors become friends.\" Dive into our reviews to uncover the heartfelt stories and experiences that make living here exceptional. See what our residents have to say about life at Atrium Court!",
  "property_created_at": "1771529574414",
  "property_scheduletour_blurb": "At Atrium Court in sunny Phoenix, AZ, each thoughtfully designed one and two-bedroom apartment offers a perfect blend of comfort and style. Ready to see the charm for yourself? Schedule a tour today and hear firsthand from our satisfied residents about what makes this community feel like home!",
  "property_thankyou_blurb": "Thank you for reaching out to Atrium Court! Nestled in the heart of Phoenix, our stylish one and two-bedroom apartments offer the perfect blend of comfort and modern living. Keep an eye out—our team will be in touch soon to help you find your ideal home at Atrium Court!",
  "property_virtualtours_blurb": "At Atrium Court in Phoenix, AZ, our thoughtfully designed one and two-bedroom apartments offer stylish comfort and vibrant living. Immerse yourself in our inviting community by taking a virtual tour today and envision your new home amid stunning amenities and a welcoming atmosphere. Your ideal living space awaits!",
  "property_copyright": "2026 All Rights Reserved. Atrium Court",
  "property_seo_title_home": "Atrium Court |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Experience luxury at Atrium Court! Spacious 1-2BR apartments with resort amenities in pet-friendly Phoenix. Find your home today!",
  "property_seo_title_floorplans": "Floor Plans | Phoenix, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal haven at Atrium Court in Phoenix, AZ. Choose from stylish one and two-bedroom floor plans tailored for comfort and convenience!",
  "property_seo_title_amenities": "Amenities | Phoenix, AZ Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Atrium Court, Phoenix! Enjoy resort-style pools, a fitness center, pet-friendly areas, and modern amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Experience resort-style living at Atrium Court, Phoenix! Enjoy lush landscapes, a sparkling pool, fitness center, and dog-friendly vibes. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Atrium Court Apartments",
  "property_seo_description_virtualtours": "Step inside Atrium Court in Phoenix, AZ! Take a virtual tour of our stylish one and two-bedroom apartments designed for comfort and convenience.",
  "property_seo_title_interactivemap": "Interactive Map | Atrium Court Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Atrium Court in Phoenix, AZ! Use our interactive map to see available one and two-bedroom apartments with resort-style amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Uncover the charm of Phoenix at Atrium Court! Dive into nearby favorites and hotspots that make our vibrant neighborhood a perfect place to call home.",
  "property_seo_title_contact": "Contact Us | Atrium Court",
  "property_seo_description_contact": "Connect with Atrium Court in Phoenix! Inquire about our spacious one- and two-bedroom floor plans today. Your new home awaits—reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Discover answers at Atrium Court, Phoenix, AZ. Explore our stunning amenities and community features designed for your comfort!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Join our vibrant community at Atrium Court in Phoenix, AZ! Hear from residents about their experiences and enjoy top-notch amenities and welcoming vibes.",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Elevate your lifestyle at Atrium Court in Phoenix! Choose modern one or two-bedroom layouts and enjoy resort-style amenities. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | Atrium Court",
  "property_seo_description_residentaccess": "Unlock seamless living at Atrium Court in Phoenix! Access your resident portal for rent payments, maintenance requests, and community updates—all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Atrium Court",
  "property_seo_description_referafriend": "Great friends make great neighbors at Atrium Court in Phoenix! Refer a friend today and share the joy of vibrant living in our welcoming community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Atrium Court",
  "property_seo_description_scheduletour": "Experience luxury living at Atrium Court in Phoenix, AZ. Schedule your tour today and step into a vibrant community designed for modern lifestyles!",
  "property_seo_title_privacy": "Privacy Policy | Atrium Court",
  "property_seo_description_privacy": "Your privacy matters at Atrium Court in Phoenix, AZ. Read our comprehensive policy to learn how we protect your data and respect your personal space.",
  "property_seo_title_accessibility": "Website Accessibility | Atrium Court",
  "property_seo_description_accessibility": "At Atrium Court in Phoenix, AZ, we prioritize digital inclusion for all. Experience seamless accessibility tailored to your needs—join our community today!",
  "property_seo_title_sitemap": "Sitemap | Atrium Court",
  "property_seo_description_sitemap": "Unravel the charm of Atrium Court in Phoenix, AZ. Navigate our sitemap for a seamless journey through your future home and community amenities!",
  "property_seo_title_thankyou": "Thank You | Atrium Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Atrium Court in Phoenix! Our team will be in touch soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293660962",
  "amenities": [
    {
      "id": "ec_b0f39d1fb3e423b076fc67c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6af2b7deedf899cb907e023",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53e523af8734e74bf5712322",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7ba8f4137507f9b826999ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7e5927fe66aa5e3e1656c00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi common areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb7e30b9893cf380337ed88c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d8e7575acf20856310f157d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_432389a0f67ce549ff4a7fb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed061b03efec58b7ea88fbcd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e857c27ce63c6d1dbc0882a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Walking/Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ded3cb2ef451872dd016e8b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76fc6558fee7ee7fc1fa8a34",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74e7f465be86131c15ac6543",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_816e9b7ccfe6262559ed312a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65e4e17dedb69e41979824b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce8c993ec075caa5adad356c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_984cbb286ac85739a4654736",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_389eb3a96664bbdb5bdfaa5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab1e5768668882c37068a833",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2515e6dc735ddf239139c16d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca8a3d9275dedace96ea4ec2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b21503e2ab575e55567ec1cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d1270608d339ead8fe8555e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a4920dbf69ffb9a1a83bf72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5338325d6e1be2651f7c26d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1684fba7fc2a7186b3e9c96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1264c7d65ae10691d55cac91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_649459070028ba167a8fece5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee58163ee34164006a5af181",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d29ea223a13cb7a9bb63ae2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6486846917da3288b244a5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6b816a594323845b35b75e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30164a2ec63584fbb0ab41db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95545c85d3a096bc03e80a84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Skylights",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a3aa526eca82fb8fd8a206d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f908630d42e59bd1719babd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_404b7471f9e632647e0166ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_bf29588b48198495efb6690f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-2066-769d-803d-9d2fb52b314b.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, and entertainment center.",
        "public_id": "019d0215-2066-769d-803d-9d2fb52b314b",
        "storage_key": "property/6767906449167135/019d0215-2066-769d-803d-9d2fb52b314b.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, armchair, and entertainment center, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with sofa, armchair, and entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (1).jpg"
    },
    {
      "id": "ec_1886486dd3736ef460bfb274",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-2058-752d-a778-414626c5dea9.webp",
      "image_media": {
        "alt_text": "Living room, dining area, and kitchen of an apartment.",
        "public_id": "019d0215-2058-752d-a778-414626c5dea9",
        "storage_key": "property/6767906449167135/019d0215-2058-752d-a778-414626c5dea9.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly flows into a dining space and a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room, dining area, and kitchen of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (2).jpg"
    },
    {
      "id": "ec_02e432ac5780bdb2fe802a62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-20e3-711a-82eb-2f6f7982cb98.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, wooden cabinets, and stainless steel sink. Living area visible in background.",
        "public_id": "019d0215-20e3-711a-82eb-2f6f7982cb98",
        "storage_key": "property/6767906449167135/019d0215-20e3-711a-82eb-2f6f7982cb98.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, ample wooden cabinet storage, and a double basin sink. The adjacent living space offers a comfortable seating area and access to a balcony.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, wooden cabinets, and stainless steel sink. Living area visible in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (3).jpg"
    },
    {
      "id": "ec_aa29aa701fa9c6af9ee7d350",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-2078-7505-8fba-c1ce7db1bbbb.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d0215-2078-7505-8fba-c1ce7db1bbbb",
        "storage_key": "property/6767906449167135/019d0215-2078-7505-8fba-c1ce7db1bbbb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet storage, a full-size refrigerator, and a double-basin sink.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, black appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (4).jpg"
    },
    {
      "id": "ec_061d7d1e81bbddff57e89b54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-295b-7230-adcd-951eabe0ff2a.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table and four upholstered chairs, adjacent to a kitchen island with bar stools.",
        "public_id": "019d0215-295b-7230-adcd-951eabe0ff2a",
        "storage_key": "property/6767906449167135/019d0215-295b-7230-adcd-951eabe0ff2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, complete with a stylish chandelier and a breakfast bar perfect for casual dining.",
      "link": "false",
      "alt_text": "Dining area with a glass-top table and four upholstered chairs, adjacent to a kitchen island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (5).jpg"
    },
    {
      "id": "ec_fdc06c1f27ab90e4594e72b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-2a87-742c-bebf-f97ffbd2876b.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a queen-size bed, large window, and a spacious closet.",
        "public_id": "019d0215-2a87-742c-bebf-f97ffbd2876b",
        "storage_key": "property/6767906449167135/019d0215-2a87-742c-bebf-f97ffbd2876b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Discover comfort in this inviting bedroom, complete with a plush queen bed, ample natural light from the large window, and a generous closet for all your storage needs.",
      "link": "false",
      "alt_text": "A cozy bedroom featuring a queen-size bed, large window, and a spacious closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (6).jpg"
    },
    {
      "id": "ec_1f550bdcbb5b5420fb1919c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-2a87-742c-bebf-f7381c775e62.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and artwork.",
        "public_id": "019d0215-2a87-742c-bebf-f7381c775e62",
        "storage_key": "property/6767906449167135/019d0215-2a87-742c-bebf-f7381c775e62.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable queen-size bed, elegant nightstand with a lamp, and tasteful wall art. This space offers a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (7).jpg"
    },
    {
      "id": "ec_2c184d0c263ef8614888343e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3019-710b-a3dd-929b4c6d97ee.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, granite countertop, wooden cabinets, and mirror with artwork. Stacked washer and dryer visible.",
        "public_id": "019d0215-3019-710b-a3dd-929b4c6d97ee",
        "storage_key": "property/6767906449167135/019d0215-3019-710b-a3dd-929b4c6d97ee.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a vanity with a sink and granite countertop, wooden cabinets, and a decorative mirror. In-unit stacked washer and dryer for convenience.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, granite countertop, wooden cabinets, and mirror with artwork. Stacked washer and dryer visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (8).jpg"
    },
    {
      "id": "ec_dcdca4809867eaac138be42f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3442-71a8-bc26-23c08e672e24.webp",
      "image_media": {
        "alt_text": "View of apartment buildings and a swimming pool.",
        "public_id": "019d0215-3442-71a8-bc26-23c08e672e24",
        "storage_key": "property/6767906449167135/019d0215-3442-71a8-bc26-23c08e672e24.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Experience the relaxing resort-style swimming pool and the beautifully landscaped grounds of this apartment community.",
      "link": "false",
      "alt_text": "View of apartment buildings and a swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (9).jpg"
    },
    {
      "id": "ec_0efb345c698ada0bc608d15d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3638-7671-bffa-28f4c887c8ef.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a large window and an open closet",
        "public_id": "019d0215-3638-7671-bffa-28f4c887c8ef",
        "storage_key": "property/6767906449167135/019d0215-3638-7671-bffa-28f4c887c8ef.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom with ample closet space and natural light from a large window.",
      "link": "false",
      "alt_text": "Empty bedroom with a large window and an open closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (10).jpg"
    },
    {
      "id": "ec_0ef38bb4870a0c341489465c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-363b-7198-b136-35b8cd61ef39.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a large swimming pool and lounge chairs.",
        "public_id": "019d0215-363b-7198-b136-35b8cd61ef39",
        "storage_key": "property/6767906449167135/019d0215-363b-7198-b136-35b8cd61ef39.webp",
        "width": 380,
        "height": 275
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas, perfect for soaking up the sun.",
      "link": "false",
      "alt_text": "Apartment complex courtyard with a large swimming pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (11).jpg"
    },
    {
      "id": "ec_3d97b1c32e8b7d97aa424216",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3b8d-753f-87ac-1d61c1a22b6c.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and tables.",
        "public_id": "019d0215-3b8d-753f-87ac-1d61c1a22b6c",
        "storage_key": "property/6767906449167135/019d0215-3b8d-753f-87ac-1d61c1a22b6c.webp",
        "width": 380,
        "height": 275
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Community swimming pool with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (12).jpg"
    },
    {
      "id": "ec_b6987466629e5b94906b03c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3ee5-7024-8035-3a3479e438a5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d0215-3ee5-7024-8035-3a3479e438a5",
        "storage_key": "property/6767906449167135/019d0215-3ee5-7024-8035-3a3479e438a5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling resort-style pool, surrounded by comfortable lounge chairs perfect for sunbathing.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (13).jpg"
    },
    {
      "id": "ec_a9087e109c199ccea5f859cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3f05-76d1-952e-44b1ef1415ac.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d0215-3f05-76d1-952e-44b1ef1415ac",
        "storage_key": "property/6767906449167135/019d0215-3f05-76d1-952e-44b1ef1415ac.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the community's sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (14).jpg"
    },
    {
      "id": "ec_74372cfc6bdd0b5afa56e8ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-3f12-767b-a343-a66994e77f7b.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machine in a fitness center with a view of the outdoor pool.",
        "public_id": "019d0215-3f12-767b-a343-a66994e77f7b",
        "storage_key": "property/6767906449167135/019d0215-3f12-767b-a343-a66994e77f7b.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and a view of the resort-style pool. Stay active and energized.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machine in a fitness center with a view of the outdoor pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (15).jpg"
    },
    {
      "id": "ec_cb9a52e49ae2d2c3d51a4eec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-4681-721f-975e-cf37e9e2a8b1.webp",
      "image_media": {
        "alt_text": "Lounge area with seating and a coffee table, with doors leading to an outdoor pool area.",
        "public_id": "019d0215-4681-721f-975e-cf37e9e2a8b1",
        "storage_key": "property/6767906449167135/019d0215-4681-721f-975e-cf37e9e2a8b1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lounge area, perfect for socializing or enjoying a quiet moment. Step outside to the sparkling pool for a refreshing dip.",
      "link": "false",
      "alt_text": "Lounge area with seating and a coffee table, with doors leading to an outdoor pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (16).jpg"
    },
    {
      "id": "ec_6b3fbf40d200fde7f8549995",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-4a29-72e1-a9bd-49e4d681f970.webp",
      "image_media": {
        "alt_text": "Business center with a computer, chairs, and a coffee station with a mini-fridge.",
        "public_id": "019d0215-4a29-72e1-a9bd-49e4d681f970",
        "storage_key": "property/6767906449167135/019d0215-4a29-72e1-a9bd-49e4d681f970.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Utilize our convenient business center, complete with a computer, copier, and a refreshment station featuring coffee and a mini-fridge.",
      "link": "false",
      "alt_text": "Business center with a computer, chairs, and a coffee station with a mini-fridge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (17).jpg"
    },
    {
      "id": "ec_98432290cb7777d8b155901c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-4b6b-75d9-bd63-991af4366716.webp",
      "image_media": {
        "alt_text": "Atrium Court leasing office entrance with terracotta roof and planters.",
        "public_id": "019d0215-4b6b-75d9-bd63-991af4366716",
        "storage_key": "property/6767906449167135/019d0215-4b6b-75d9-bd63-991af4366716.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Atrium Court's leasing office, featuring a beautiful entrance with colorful flowers and lush greenery.",
      "link": "false",
      "alt_text": "Atrium Court leasing office entrance with terracotta roof and planters.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (18).jpg"
    },
    {
      "id": "ec_c32d0b17f5c89d1e994bdcfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0215-4c02-764c-89af-4ad187813fb9.webp",
      "image_media": {
        "alt_text": "Atrium Court Apartment Homes monument sign with address 2323 and property map.",
        "public_id": "019d0215-4c02-764c-89af-4ad187813fb9",
        "storage_key": "property/6767906449167135/019d0215-4c02-764c-89af-4ad187813fb9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Atrium Court Apartment Homes, located at 2323. View our property map to explore the community amenities and grounds.",
      "link": "false",
      "alt_text": "Atrium Court Apartment Homes monument sign with address 2323 and property map.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Atrium-Court_Favorites (19).jpg"
    },
    {
      "id": "ec_b8a08b58352005d0b633df9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019e4fe2-33d8-70db-a8aa-97d939e64af9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool area with lounge chairs and a clubhouse.",
        "public_id": "019e4fe2-33d8-70db-a8aa-97d939e64af9",
        "storage_key": "property/6767906449167135/019e4fe2-33d8-70db-a8aa-97d939e64af9.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and unwinding after a long day. Surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "Resort-style swimming pool area with lounge chairs and a clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Atrium-Court_Gym-Outside-1.jpg"
    },
    {
      "id": "ec_926a9dafa4ee40fbe0bf42cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019e4fe2-38cf-7290-8ad5-3092c3d107a7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
        "public_id": "019e4fe2-38cf-7290-8ad5-3092c3d107a7",
        "storage_key": "property/6767906449167135/019e4fe2-38cf-7290-8ad5-3092c3d107a7.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and tables for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Atrium-Court_Gym-Outside-2.jpg"
    },
    {
      "id": "ec_1b8510e741e21a3fc4afcc8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019e4fe2-33d8-70db-a8aa-97d939e64af9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool area with lounge chairs and a clubhouse.",
        "public_id": "019e4fe2-33d8-70db-a8aa-97d939e64af9",
        "storage_key": "property/6767906449167135/019e4fe2-33d8-70db-a8aa-97d939e64af9.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and unwinding after a long day. Surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "Resort-style swimming pool area with lounge chairs and a clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Atrium-Court_Gym-Outside-1.jpg"
    },
    {
      "id": "ec_a7fc28e2f9de3564c9343b6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019e4fe2-38cf-7290-8ad5-3092c3d107a7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
        "public_id": "019e4fe2-38cf-7290-8ad5-3092c3d107a7",
        "storage_key": "property/6767906449167135/019e4fe2-38cf-7290-8ad5-3092c3d107a7.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and tables for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Atrium-Court_Gym-Outside-2.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7e40c7dc-c95d-42ba-8ba1-70fbd763013d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "4840 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, fries, and shakes. They highlight the fresh ingredients, reasonable prices, and fast service. They also like the friendly staff and efficient service.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.in-n-out.com/317",
      "poi_directions_map_url": "https://maps.google.com/?cid=10864970382485718219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.507194",
      "poi_longitude": "-112.0393252",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-8f4e-705f-92d2-15bfeac42167",
        "storage_key": "property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd6fS2QNK4cRy4Qzb_8gyJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_5083412e-7799-4643-89b3-08944fea6dfe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Bobby-Q BBQ Restaurant and Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "8501 N 27th Ave, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly eatery serving steak, BBQ ribs & other American comfort items in a rustic setting.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and pulled pork, and the Q rolls and cornbread are highly recommended. They highlight the generous portions, reasonable prices, and the complimentary donuts at the end of the meal. They also like the friendly and attentive service, and the fun, lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d150-732f-befd-a0c250365256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d150-732f-befd-a0c250365256",
        "storage_key": "property/6767906449167135/019d0216-d150-732f-befd-a0c250365256.webp",
        "width": 1124,
        "height": 634
      },
      "poi_business_url": "https://bobbyqbbq.com/phoenix-bbq-restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11940719194717959783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bobby-q-bbq-restaurant-and-steakhouse",
      "poi_latitude": "33.560937",
      "poi_longitude": "-112.1158642",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-995-5982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-8f4e-705f-92d2-15bfeac42167",
        "storage_key": "property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dBh__RsK4cRZzbay9f0taU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_57b17ed1-8020-4b32-8a95-f6ceb6eab76b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Pappadeaux Seafood Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11051 N Black Cyn Hwy, Phoenix, AZ 85029, USA",
      "poi_short_description": "Cajun-style seafood, pastas & comfort fare served in a dark wood eatery with a full bar.",
      "poi_long_description": "People say this seafood restaurant serves fresh and flavorful seafood, including gumbo, shrimp salad, and crab cakes. They highlight the generous portions, the lively and beautiful atmosphere, and the attentive service. They also like the outdoor water fountain and surrounding plant life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d0ce-72a9-9d21-2209db7b4505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d0ce-72a9-9d21-2209db7b4505",
        "storage_key": "property/6767906449167135/019d0216-d0ce-72a9-9d21-2209db7b4505.webp",
        "width": 886,
        "height": 349
      },
      "poi_business_url": "https://pappadeaux.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13477599013761038707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pappadeaux-seafood-kitchen",
      "poi_latitude": "33.587819",
      "poi_longitude": "-112.1158724",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-331-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-8f4e-705f-92d2-15bfeac42167",
        "storage_key": "property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Wnq1T1sK4cRc7lhSOUMCrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_260b3c66-4bf4-4edd-91fd-9b153c7a57c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Culinary Dropout",
      "poi_type": "Restaurants",
      "poi_address": "5632 N 7th St, Phoenix, AZ 85014, USA",
      "poi_short_description": "Cool, British-style gastropub chain with quirky decor, serving inventive cocktails & comfort food.",
      "poi_long_description": "Diners say this American restaurant serves up delicious brussel sprouts, fried chicken, fish and chips, and pretzel bites, and they praise the lively atmosphere with outdoor seating, cornhole, and ping pong. They also highlight the friendly and attentive service, and many appreciate the complimentary valet parking.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d0ce-72a9-9d21-15751238e80a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d0ce-72a9-9d21-15751238e80a",
        "storage_key": "property/6767906449167135/019d0216-d0ce-72a9-9d21-15751238e80a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.culinarydropout.com/locations/phoenix-az/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2103499372696634781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culinary-dropout",
      "poi_latitude": "33.519589",
      "poi_longitude": "-112.0654512",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-680-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-8f4e-705f-92d2-15bfeac42167",
        "storage_key": "property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6g1AroSK4cRnQXX3oghMR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_951f4a95-5086-4958-872d-78fd44b9a02a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5679 W Northern Ave, Glendale, AZ 85301, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of comfort food, including pot roast, fried chicken, steak, and a fresh salad bar, with many praising the delicious yeast rolls and extensive dessert selection. They also highlight the friendly and attentive staff, and the great value for the price, especially during off-peak hours.\n\nSome reviews mention the food can be inconsistent in quality.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d0ce-72a9-9d21-1ef3d92ea6b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d0ce-72a9-9d21-1ef3d92ea6b0",
        "storage_key": "property/6767906449167135/019d0216-d0ce-72a9-9d21-1ef3d92ea6b0.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2530/golden-corral-w-northern-avenue?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2530",
      "poi_directions_map_url": "https://maps.google.com/?cid=16146451116213055299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "33.552664",
      "poi_longitude": "-112.181616",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-937-0866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-8f4e-705f-92d2-15bfeac42167",
        "storage_key": "property/6767906449167135/019d0216-8f4e-705f-92d2-15bfeac42167.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoc_4NKhrK4cRQ68WHb63E-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_cdc5b040-83fb-45b3-b70b-d74a7ff35d12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4701 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, seafood, and bakery items, as well as a hot and cold food bar, deli, and pizza bar. They also highlight the convenient Amazon return service, the clean and organized layout, and the friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/camelback?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1444832490836523548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.5064733",
      "poi_longitude": "-112.0376627",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 602-761-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-9441-7539-975f-f8a632c09ab3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-9441-7539-975f-f8a632c09ab3",
        "storage_key": "property/6767906449167135/019d0216-9441-7539-975f-f8a632c09ab3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-_kVWQNK4cRHPpA0H4TDRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_64d71e43-7f5b-416d-9b24-ee610fcc7589",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4821 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, frozen vegetables, and unique snacks, as well as beautiful flowers and live plants. They highlight the reasonable prices and the fun, festive vibe, especially during the fall season. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d507-7721-9e5c-b73e57a26e1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d507-7721-9e5c-b73e57a26e1e",
        "storage_key": "property/6767906449167135/019d0216-d507-7721-9e5c-b73e57a26e1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/az/phoenix/90/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10694691880053583102&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.5070967",
      "poi_longitude": "-112.0377182",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 602-912-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-9441-7539-975f-f8a632c09ab3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-9441-7539-975f-f8a632c09ab3",
        "storage_key": "property/6767906449167135/019d0216-9441-7539-975f-f8a632c09ab3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoY_8TGQNK4cR_izZHJota5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3407f432-5736-404e-a9de-5956555f7e47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "330 W Bell Rd, Phoenix, AZ 85023, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, meat, and bulk items, including spices, candy, and baking supplies. They highlight the low prices, convenient 24-hour opening hours, and self-checkout option. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d5a8-777b-887f-2dd7d81a0f16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d5a8-777b-887f-2dd7d81a0f16",
        "storage_key": "property/6767906449167135/019d0216-d5a8-777b-887f-2dd7d81a0f16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777022528232851537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "33.641162",
      "poi_longitude": "-112.079758",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-978-2730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-9441-7539-975f-f8a632c09ab3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-9441-7539-975f-f8a632c09ab3",
        "storage_key": "property/6767906449167135/019d0216-9441-7539-975f-f8a632c09ab3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaQMRERuK4cRUYhDibKHEs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_937857ce-b49c-4d56-b843-129c6dfd3c15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4848 N 43rd Ave, Phoenix, AZ 85031, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and has everything you need. They also highlight the helpful and friendly staff, and the quick service.\n\nOther reviews mention the online inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d5f8-725a-a2af-c46a2498e9f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d5f8-725a-a2af-c46a2498e9f8",
        "storage_key": "property/6767906449167135/019d0216-d5f8-725a-a2af-c46a2498e9f8.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Camelback/AZ/Phoenix/85031/485?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4848399312888276305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.5075014",
      "poi_longitude": "-112.1530413",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-849-0125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ef-7592-945e-fc9c87a11c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ef-7592-945e-fc9c87a11c61",
        "storage_key": "property/6767906449167135/019d0216-93ef-7592-945e-fc9c87a11c61.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNzutaa4UK4cRUSX0tXz5SEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_18b441b5-70ff-4fa0-ae26-01ec07195a6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Biltmore Fashion Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "2502 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Upscale shopping mall with high-end department stores & retailers, plus restaurants & fast food.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including groceries, dining, and basic services, as well as a selection of restaurants. They highlight the convenient parking, clean and safe environment, and shaded walkways. They also like the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-d66c-716a-ba43-be3fedcc56c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-d66c-716a-ba43-be3fedcc56c0",
        "storage_key": "property/6767906449167135/019d0216-d66c-716a-ba43-be3fedcc56c0.webp",
        "width": 1280,
        "height": 1004
      },
      "poi_business_url": "https://www.shopbiltmore.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989761710559018186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "biltmore-fashion-park",
      "poi_latitude": "33.5108735",
      "poi_longitude": "-112.0279366",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-954-6810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ef-7592-945e-fc9c87a11c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ef-7592-945e-fc9c87a11c61",
        "storage_key": "property/6767906449167135/019d0216-93ef-7592-945e-fc9c87a11c61.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRyjyfSdtUBtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4b82e444-28ce-4dbb-880e-e5a7da80143a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Grand Canyon University",
      "poi_type": "Education",
      "poi_address": "3300 W Camelback Rd, Phoenix, AZ 85017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-86a3-7077-ae28-642fa3363777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-86a3-7077-ae28-642fa3363777",
        "storage_key": "property/6767906449167135/019d0216-86a3-7077-ae28-642fa3363777.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14902340455442424245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grand-canyon-university",
      "poi_latitude": "33.5100339",
      "poi_longitude": "-112.1288588",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-639-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-98ef-73f9-a0f4-1c58cc02a912",
        "storage_key": "property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj7t3FE4TK4cRtSGUMLC_z84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_35af9dd5-39b9-4cde-abaf-259395578de3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Glendale Community College",
      "poi_type": "Education",
      "poi_address": "6000 W Olive Ave, Glendale, AZ 85302, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-da3a-70aa-a429-1347fa99aa29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-da3a-70aa-a429-1347fa99aa29",
        "storage_key": "property/6767906449167135/019d0216-da3a-70aa-a429-1347fa99aa29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gccaz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=954649757192534245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-community-college",
      "poi_latitude": "33.5694333",
      "poi_longitude": "-112.1908271",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-845-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-98ef-73f9-a0f4-1c58cc02a912",
        "storage_key": "property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ52NxVbVrK4cR5bhfbuWYPw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b12d006d-e3f6-45e4-a06a-c4a62c2665c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Phoenix College",
      "poi_type": "Education",
      "poi_address": "1202 W Thomas Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-daae-77f5-a229-a68159c7554e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-daae-77f5-a229-a68159c7554e",
        "storage_key": "property/6767906449167135/019d0216-daae-77f5-a229-a68159c7554e.webp",
        "width": 512,
        "height": 341
      },
      "poi_business_url": "http://www.phoenixcollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8690102689232332964&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-college",
      "poi_latitude": "33.4831677",
      "poi_longitude": "-112.0892708",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-285-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-98ef-73f9-a0f4-1c58cc02a912",
        "storage_key": "property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ32PXBlYSK4cRpChcjVpymXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fde557fb-ab32-401a-ab60-e7981abba40b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Arizona State University West Valley Campus",
      "poi_type": "Education",
      "poi_address": "4701 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-db22-7327-a8c1-23482248f262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-db22-7327-a8c1-23482248f262",
        "storage_key": "property/6767906449167135/019d0216-db22-7327-a8c1-23482248f262.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=14857680985714674109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-state-university-west-valley-campus",
      "poi_latitude": "33.6079039",
      "poi_longitude": "-112.1609696",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-543-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-98ef-73f9-a0f4-1c58cc02a912",
        "storage_key": "property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi7CNmFxpK4cRvUmZGyMWMc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_61c78cb0-d088-4cf8-a683-5e5b4b79d3fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "ASU WEST",
      "poi_type": "Education",
      "poi_address": "7000 University Way N, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-dc80-76b6-819b-ffed22889bac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-dc80-76b6-819b-ffed22889bac",
        "storage_key": "property/6767906449167135/019d0216-dc80-76b6-819b-ffed22889bac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=17607851155726739029&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "asu-west",
      "poi_latitude": "33.6090958",
      "poi_longitude": "-112.160189",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-98ef-73f9-a0f4-1c58cc02a912",
        "storage_key": "property/6767906449167135/019d0216-98ef-73f9-a0f4-1c58cc02a912.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW3qhzzppK4cRVSYL81WnW_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f75ffb2c-e7ab-4558-8c24-a57044f4883d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Castles N' Coasters",
      "poi_type": "Entertainment",
      "poi_address": "9445 N Metro Pkwy E, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly destination for mini-golf, go-kart rides, roller coasters & an arcade.",
      "poi_long_description": "People say this amusement park offers a variety of fun rides, mini golf courses, and arcade games. They also highlight the reasonable prices, especially with the unlimited ride pass, and the fun, family-friendly atmosphere.\n\nOther reviews mention the rides can be closed during certain times.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.castlesncoasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14386602448939149210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "castles-n-coasters",
      "poi_latitude": "33.5725174",
      "poi_longitude": "-112.1188154",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-997-7575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xgSK4cRmmfILbR6p8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3c13ed8a-036e-48cd-9f5b-ac0e4eae4b0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Martin Auto Museum and Event Center",
      "poi_type": "Entertainment",
      "poi_address": "4320 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "Fascinating space featuring over 170 cars spanning 130 years of history such as hot rods and Shelby Cobras.",
      "poi_long_description": "People say this museum offers a vast collection of vintage and classic cars, as well as a carousel and game room. They highlight the affordable price, the opportunity to sit in many of the cars, and the clean and well-maintained facilities. They also like the friendly, knowledgeable, and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-de3a-754a-bb3b-d1da6eb7f965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-de3a-754a-bb3b-d1da6eb7f965",
        "storage_key": "property/6767906449167135/019d0216-de3a-754a-bb3b-d1da6eb7f965.webp",
        "width": 828,
        "height": 466
      },
      "poi_business_url": "https://www.martinautomuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9291038243856928640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-auto-museum-and-event-center",
      "poi_latitude": "33.6122996",
      "poi_longitude": "-112.1525224",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-298-2377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-98ef-73f9-a0f4-2389c9ad0729.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-98ef-73f9-a0f4-2389c9ad0729",
        "storage_key": "property/6767906449167135/019d0216-98ef-73f9-a0f4-2389c9ad0729.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetTmuFuK4cRgE-phw5m8IA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_348aceb9-2adc-411f-afbe-c5458d314d33",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Global Credit Union Arena",
      "poi_type": "Entertainment",
      "poi_address": "3300 W Camelback Rd Building 38, Phoenix, AZ 85017, USA",
      "poi_short_description": "Medium-sized arena at Grand Canyon University seating 7,000, staging concerts and basketball games.",
      "poi_long_description": "People say this arena is a great place to watch basketball and host events like graduations and orientations. They highlight the spaciousness, ideal size for viewing, and fun atmosphere, especially during games. They also like the welcoming staff and students.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.gcuarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774516067949477999&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "global-credit-union-arena",
      "poi_latitude": "33.5097451",
      "poi_longitude": "-112.1286043",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-639-8979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5e8isk8TK4cRbwCavDDEq_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_a0fc29ca-d578-4047-bafc-99f3ca55d34b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "River Ranch Water Park",
      "poi_type": "Entertainment",
      "poi_address": "7667 N 18th Pl, Phoenix, AZ 85020, USA",
      "poi_short_description": "Water park featuring a lazy river, along with mini-golf and a restaurant.",
      "poi_long_description": "Visitors say this water park has a lazy river, a waterslide, and a pool with a volleyball net and waterfall. They also highlight the availability of cabana rentals, day passes, and towels.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15631802649349206176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-ranch-water-park",
      "poi_latitude": "33.5486089",
      "poi_longitude": "-112.0439762",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfYjWxBzK4cRoDB4UbBR79g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_c93c2fbf-3c8b-4f57-8c2d-e0be61a946e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "GCU Stadium",
      "poi_type": "Entertainment",
      "poi_address": "3300 W Camelback Rd, Phoenix, AZ 85017, USA",
      "poi_short_description": "Stadium offering soccer games with views from every seat, plus Wi-Fi.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://gculopes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13079383176715704500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gcu-stadium",
      "poi_latitude": "33.5121007",
      "poi_longitude": "-112.1313258",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-639-8979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-f522-7218-9b8e-326a7986a446.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-f522-7218-9b8e-326a7986a446",
        "storage_key": "property/6767906449167135/019d0216-f522-7218-9b8e-326a7986a446.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxZmf5VETK4cRtBhcobNNg7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e4e16241-4ef8-4e4d-9635-643bb6f49175",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4355 W Glendale Ave, Glendale, AZ 85301, USA",
      "poi_short_description": "Chain fitness center providing treadmills, free weights and cardio machines.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and recovery options, as well as classes, a pool, and saunas. They also highlight the clean facilities, welcoming and supportive staff, and motivating atmosphere.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-df05-76ac-bc21-5cf73b5e0a11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-df05-76ac-bc21-5cf73b5e0a11",
        "storage_key": "property/6767906449167135/019d0216-df05-76ac-bc21-5cf73b5e0a11.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/glendale-w-glendale-ave-n-43rd-ave/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5604531485536589995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.5373189",
      "poi_longitude": "-112.1532319",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-848-3572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-35pGdrK4cRq5jmJ7FLx00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f131f547-5e30-4fea-8357-9df3da47768a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Life Time Biltmore",
      "poi_type": "Health and Wellness",
      "poi_address": "2580 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a rooftop pool, Pilates classes, and a variety of workout equipment.\n\nOther reviews mention the facilities can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-df59-72ed-b6d9-24fcfb46999f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-df59-72ed-b6d9-24fcfb46999f",
        "storage_key": "property/6767906449167135/019d0216-df59-72ed-b6d9-24fcfb46999f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/biltmore.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=14753527583408917087&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time-biltmore",
      "poi_latitude": "33.5106711",
      "poi_longitude": "-112.0257407",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 623-244-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4exgSsNK4cRXwoEaSsPv8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9119103f-bbee-4a5f-8701-d2742cfdec92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8021 N 35th Ave, Phoenix, AZ 85051, USA",
      "poi_short_description": "Indoor pool, sauna and basketball court along with weight-training machines at clean gym.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, classes, and amenities, including a pool, sauna, and steam room. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the membership can be difficult to cancel.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://vasafitness.com/locations/az/phoenix-northern/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8722081819687322271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.554039",
      "poi_longitude": "-112.1320266",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-610-8078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2XKMrRttK4cRnwJbFDQPC3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d8790e76-d213-4cd7-a889-3ebe00f217ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2077 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Clean chain for cardio, Pilates, yoga and strength training, plus a pool, basketball court and sauna.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and a clean workout environment.\n\nOther reviews mention the hours can be inconvenient and the staff can be unhelpful.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=232&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17086058318366249808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.5074129",
      "poi_longitude": "-112.0369734",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 602-241-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJre8va2wNK4cRUBPUxYPfHe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6d07fd3a-faa3-4bdd-b4f5-5726aa6f566e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1625 W Camelback Rd, Phoenix, AZ 85015, USA",
      "poi_short_description": "Workout facility equipped with cardio machines, dumbbells and free weights, plus massage chairs.",
      "poi_long_description": "People say this gym offers a variety of equipment and is conveniently located. They also highlight the gym is clean and the staff is friendly and helpful.\n\nOther reviews mention the gym can be closed due to power outages.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.planetfitness.com/gyms/phoenix-alhambra-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2585588648961876717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.5082027",
      "poi_longitude": "-112.0950049",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-374-4341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSpSWd8SK4cR7aKnXC3b4SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_625f41f0-1e1b-447f-afcd-1ac62dc1cb25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Banner Thunderbird Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-e0e6-713c-b772-cad63459b731.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-e0e6-713c-b772-cad63459b731",
        "storage_key": "property/6767906449167135/019d0216-e0e6-713c-b772-cad63459b731.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/glendale/banner-thunderbird-medical-center?y_source=1_MTE5MDczNTItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11031221542305799944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-thunderbird-medical-center",
      "poi_latitude": "33.6093624",
      "poi_longitude": "-112.1801493",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-865-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-99bd-71a4-b9ab-8c852f267cc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-99bd-71a4-b9ab-8c852f267cc9",
        "storage_key": "property/6767906449167135/019d0216-99bd-71a4-b9ab-8c852f267cc9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnx4Z3nFpK4cRCB_G-4vFFpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_f146629f-a7b3-4100-905e-dd94a3c9fbe8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Carl T. Hayden Veterans' Administration Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "650 E Indian School Rd, Phoenix, AZ 85012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-e2cf-77af-8b69-dc36b18943ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-e2cf-77af-8b69-dc36b18943ad",
        "storage_key": "property/6767906449167135/019d0216-e2cf-77af-8b69-dc36b18943ad.webp",
        "width": 1280,
        "height": 802
      },
      "poi_business_url": "https://www.va.gov/phoenix-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001601183389442107&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carl-t-hayden-veterans-administration-medical-center",
      "poi_latitude": "33.49731",
      "poi_longitude": "-112.0668282",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 602-277-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-99bd-71a4-b9ab-8c852f267cc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-99bd-71a4-b9ab-8c852f267cc9",
        "storage_key": "property/6767906449167135/019d0216-99bd-71a4-b9ab-8c852f267cc9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxLklI0SK4cRO-AtVOaI0vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_90f1f32c-2d3d-4ce6-a9d8-cbd23d3d2f69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Steele Indian School Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 E Indian School Rd, Phoenix, AZ 85012, USA",
      "poi_short_description": "Leafy lawned park around a lake with a playground, basketball & volleyball courts & picnic shelters.",
      "poi_long_description": "People say this city park offers a variety of activities, including fishing, barbecuing, and playing volleyball, and hosts events like the Japanese Peace Festival and a doggie festival. They highlight the spacious areas, walking paths, and water features, as well as the historical significance of the site. They also like the peaceful and relaxing atmosphere, and the opportunities for recreation and education.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-e37f-74c7-8044-3c28b7ceb234.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-e37f-74c7-8044-3c28b7ceb234",
        "storage_key": "property/6767906449167135/019d0216-e37f-74c7-8044-3c28b7ceb234.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/s-parks/steele-indian-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561299676862919800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "steele-indian-school-park",
      "poi_latitude": "33.5009135",
      "poi_longitude": "-112.0708073",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-495-0935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-9c9a-70cd-a165-9db6a4771b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-9c9a-70cd-a165-9db6a4771b68",
        "storage_key": "property/6767906449167135/019d0216-9c9a-70cd-a165-9db6a4771b68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcA-YY0SK4cReLTQ2pvX9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ecefcd2b-2091-4bbc-8bcf-cc1a4df0a387",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Piestewa Peak Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Trio of trails, boasting panoramic views, desert foliage, and steep rock formations for all fitness levels.",
      "poi_long_description": "People say this hiking area offers a challenging hike with stunning views of the valley and unique rock formations. They highlight the well-maintained trail, ample parking, and convenient facilities, including bathrooms and a drinking fountain. They also like the sense of community among fellow hikers and the opportunity to connect with nature. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-e489-76ce-9f24-6538a91ee602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-e489-76ce-9f24-6538a91ee602",
        "storage_key": "property/6767906449167135/019d0216-e489-76ce-9f24-6538a91ee602.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak/hiking-trail-map",
      "poi_directions_map_url": "https://maps.google.com/?cid=12134414538075838070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piestewa-peak-trailhead",
      "poi_latitude": "33.5396234",
      "poi_longitude": "-112.0228315",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCzyevMpyK4cRdpZYQ7sZZqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_2a976853-c944-4357-aa0a-925c77f7c368",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Sahuaro Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9802 59th Ave, Glendale, AZ 85302, USA",
      "poi_short_description": "Set on old ranch grounds, this park features wandering fowl, a historic house museum & play areas.",
      "poi_long_description": "People say this park offers a playground, rose garden, historic buildings, and opportunities for picnics and barbecues. They highlight the beautiful grounds, the presence of peacocks and bunnies, and the family-friendly atmosphere. They also like the peaceful and relaxing vibe, and the opportunities for walking and enjoying the weather. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-e4b1-752e-874c-6b0bee0eda26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-e4b1-752e-874c-6b0bee0eda26",
        "storage_key": "property/6767906449167135/019d0216-e4b1-752e-874c-6b0bee0eda26.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.glendaleaz.com/parksandrecreation/sahuaroranchpark.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12960466992835098622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sahuaro-ranch-park",
      "poi_latitude": "33.5765875",
      "poi_longitude": "-112.1906328",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-9c9a-70cd-a165-9db6a4771b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-9c9a-70cd-a165-9db6a4771b68",
        "storage_key": "property/6767906449167135/019d0216-9c9a-70cd-a165-9db6a4771b68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbuutctrK4cR_ncc_w_U3LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1117cb8f-26ff-4cf0-91e2-16bb01404a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Dreamy Draw Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2421 E Northern Ave, Phoenix, AZ 85020, USA",
      "poi_short_description": "Expansive public park with miles of hiking & biking trails winding through rocky desert terrain.",
      "poi_long_description": "Hikers say this recreation area offers a wide variety of trails for all levels, from paved paths suitable for strollers and bikes to challenging hikes with scenic views. They also highlight the clean restrooms, ample parking, and plentiful water fountains, making it a convenient and enjoyable spot for outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ea06-7128-9190-1879fc3f5d4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ea06-7128-9190-1879fc3f5d4e",
        "storage_key": "property/6767906449167135/019d0216-ea06-7128-9190-1879fc3f5d4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=4114834764206794336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dreamy-draw-recreation-area",
      "poi_latitude": "33.5642105",
      "poi_longitude": "-112.0288628",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-262-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xgSK4cRYGb5rWrUGjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_1e83f430-0162-4aa2-8b4d-91dd1ac0c103",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Phoenix Mountains Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Group of parks with mountain & desert hiking trails, plus an abundance of cacti & native wildlife.",
      "poi_long_description": "People say this nature preserve offers a variety of trails for hiking, biking, and walking, with options for all levels of ability. They highlight the beautiful desert scenery, stunning views, and opportunities for solitude, especially on less popular trails. They also like the well-marked and maintained trails, and the availability of amenities such as restrooms and water bottle filling stations. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ea9c-774b-b4fc-33a38cad2752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ea9c-774b-b4fc-33a38cad2752",
        "storage_key": "property/6767906449167135/019d0216-ea9c-774b-b4fc-33a38cad2752.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=768664447671239094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-mountains-preserve",
      "poi_latitude": "33.5620742",
      "poi_longitude": "-112.0209097",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 602-261-8318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-9c9a-70cd-a165-9db6a4771b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-9c9a-70cd-a165-9db6a4771b68",
        "storage_key": "property/6767906449167135/019d0216-9c9a-70cd-a165-9db6a4771b68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UYsGO1yK4cRtoHqGj7Yqgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_18fc7358-1e23-4d25-8320-0188b9944626",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "19th Ave/Dunlap",
      "poi_type": "Transportation & Transit",
      "poi_address": "1901 W Dunlap Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ea77-77bd-a9c2-b73b57017043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ea77-77bd-a9c2-b73b57017043",
        "storage_key": "property/6767906449167135/019d0216-ea77-77bd-a9c2-b73b57017043.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valleymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10720189826567534372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "19th-avedunlap",
      "poi_latitude": "33.567376",
      "poi_longitude": "-112.10084",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoYFO8lVsK4cRJHdQadnDxZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_11410bdb-98d5-4351-abb7-f93f92313b92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "19th Ave/Camelback",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ea67-7550-a5db-9e58522fefdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ea67-7550-a5db-9e58522fefdf",
        "storage_key": "property/6767906449167135/019d0216-ea67-7550-a5db-9e58522fefdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17720015484194380135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "19th-avecamelback",
      "poi_latitude": "33.5095401",
      "poi_longitude": "-112.098769",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3szwiYTK4cRZ9nTvTIk6vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_868f4d5c-bf83-43ba-985e-155ebd67e14a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Metro Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-795d-7308-ba10-d80e82b4f786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-795d-7308-ba10-d80e82b4f786",
        "storage_key": "property/6767906449167135/019d0216-795d-7308-ba10-d80e82b4f786.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095258421458371006&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-pkwy",
      "poi_latitude": "33.575092",
      "poi_longitude": "-112.118469",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7kvo0JsK4cRvgEQiyKR9Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c49a4c9f-6f4c-40f5-8aaa-404ece28948c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Glendale/19th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17712783669072054624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale19th-ave",
      "poi_latitude": "33.537456",
      "poi_longitude": "-112.099688",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_VaEtlsK4cRYElhkuZy0PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_d1576e20-0bde-4a5d-9152-8b5075ec1301",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Indian School/Central Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=162540954658734140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "indian-schoolcentral-ave",
      "poi_latitude": "33.49575",
      "poi_longitude": "-112.073789",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1tq8PISK4cRPADjFyN2QQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_98f13d11-bd18-430e-a56b-cfc8ee8f4f8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Charles Schwab Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2423 E Lincoln Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.schwab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9818663216570429998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charles-schwab-corporate-office",
      "poi_latitude": "33.5302477",
      "poi_longitude": "-112.0291931",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-435-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVXVCUwNK4cRLvLfiCzmQog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_586ce95c-dd93-4239-a951-7ce7f19d2baa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Maricopa Ambulance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10243 N 19th Ave B, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ef24-778b-9cb8-7aa9353f79a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ef24-778b-9cb8-7aa9353f79a9",
        "storage_key": "property/6767906449167135/019d0216-ef24-778b-9cb8-7aa9353f79a9.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.maricopaambulance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12641644849842697492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maricopa-ambulance",
      "poi_latitude": "33.579714",
      "poi_longitude": "-112.09836",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-485-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9rip01sK4cRFDWFOwMlcK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e26c6476-f26a-4207-87f7-c1b5fc221ba2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Best Western Hotels & Resorts Worldwide Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6201 N 24th Pkwy, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bestwestern.com/en_US.html?iata=00171880&ssob=BLBWI0004G&cid=BLBWI0004G:google:gmb:bwhomepage",
      "poi_directions_map_url": "https://maps.google.com/?cid=1166064889675642566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "best-western-hotels--resorts-worldwide-headquarters",
      "poi_latitude": "33.5278437",
      "poi_longitude": "-112.0281983",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-957-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSv2lkgNK4cRxvYrztaxLhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a3e05e67-018d-4aa4-b586-84c6afcf6c06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Goodwill Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2626 W Beryl Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ef8b-7129-9032-f83900e0dd65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ef8b-7129-9032-f83900e0dd65",
        "storage_key": "property/6767906449167135/019d0216-ef8b-7129-9032-f83900e0dd65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.goodwillaz.org/contact/?utm_source=local&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=260774468439883183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodwill-corporate-center",
      "poi_latitude": "33.5799154",
      "poi_longitude": "-112.115543",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-535-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYG0fUFsK4cRr73ZVf90ngM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c924ee72-8376-490f-9b9e-c9d35946b4d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "BCBSAZ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8220 N 23rd Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-ef94-765e-a16a-ce96adbcec33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ef94-765e-a16a-ce96adbcec33",
        "storage_key": "property/6767906449167135/019d0216-ef94-765e-a16a-ce96adbcec33.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7153687352175926594&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bcbsaz",
      "poi_latitude": "33.557967",
      "poi_longitude": "-112.1094013",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ec-742e-9e97-c2697f373f47",
        "storage_key": "property/6767906449167135/019d0216-93ec-742e-9e97-c2697f373f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSXW67_BsK4cRQp2mtL4AR2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2ab11ee7-1160-4895-bb41-43f28f7f6202",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9600 N Metro Pkwy W, Phoenix, AZ 85051, USA",
      "poi_short_description": "",
      "poi_long_description": "Customers consistently praise this store for being clean and well-stocked with a wide variety of items, offering competitive prices, and having friendly staff who provide fast service.\n\nOther reviews mention the staff can be unhelpful and unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019fc99b-8b66-7027-8c81-81211e704399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc99b-8b66-7027-8c81-81211e704399",
        "storage_key": "property/6767906449167135/019fc99b-8b66-7027-8c81-81211e704399.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://walmart.com/store/6477?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9026228795049374435&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.572708999999996",
      "poi_longitude": "-112.12163849999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-337-0171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d0216-93ef-7592-945e-fc9c87a11c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-93ef-7592-945e-fc9c87a11c61",
        "storage_key": "property/6767906449167135/019d0216-93ef-7592-945e-fc9c87a11c61.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx44xdmhsK4cR4_JRHkSbQ30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f56c8e5ec1d2746fbe2465c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_165db488b9870c2bd2998e5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8c67d6ef82351af82a9a64d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0c5bb48e5b005e0fced3ebe7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_27eca26acdb3737695afe4a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_21df62f2-a83a-4289-be2f-b2abbc82e997",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "rating": "5.0",
      "name": "Marlenne Vazquez",
      "text": "Living at Atrium Court Apartments has been such a great experience! The community looks absolutely beautiful with the new landscaping and fresh plants — it’s clear that a lot of care and attention goes into keeping the property looking its best. The outdoor areas are vibrant, clean, and welcoming, making it such a pleasant place to come home to.\n\nThe staff here are truly wonderful — friendly, professional, and always willing to help with anything you need. They go above and beyond to make sure residents feel comfortable and appreciated.\n\nWhat really makes Atrium Court stand out is the sense of community. Neighbors are kind, and there’s a warm, friendly atmosphere that makes it easy to feel at home. Overall, it’s a peaceful, well-maintained, and genuinely enjoyable place to live. Highly recommend!",
      "date": "2025-10-23",
      "title": ""
    },
    {
      "id": "custom_98629d2f-59f0-4595-9554-d370a5383ec1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "rating": "5.0",
      "name": "Marsha Burke",
      "text": "The manager Sonya, has been extremely kind, understanding and supportive throughout my time renting. She has taken time to listen to my personal needs, and has helped me the best way she could. Any issues I’ve had have always been handled quickly and with understanding.",
      "date": "2025-10-31",
      "title": ""
    },
    {
      "id": "custom_d54d7ce1-658b-4b51-9458-b574ae2c4021",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "rating": "5.0",
      "name": "ALEX MWANGANGI",
      "text": "I give Paula 5 stars for her quick response when I went there searching for an apartment to move in. She was passionate and confident about the excellent state of the property which I found to be neat, comes with an extra storage space, a balcony, a walk in closet, a big bedroom and a great location all for a one bedroom. The price too is pocket friendly.  Thankyou Paula, keep up the good work.",
      "date": "2024-07-23",
      "title": ""
    },
    {
      "id": "custom_c9118c9d-8cf2-4b99-8856-e4ffb97ae82f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "rating": "5.0",
      "name": "Maida Mora",
      "text": "I’ve lived here for over a year and love it! The community is quiet. And the office girls, Sonia and Bella, are always so helpful. I’m really happy living here. It’s a nice place to call home!",
      "date": "2025-09-04",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_be086126-e557-4637-a8ed-97bf347173b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-06c0-73ee-a973-9463e639200f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Treadmills and elliptical in a fitness center with a pool view.",
        "public_id": "019d270f-06c0-73ee-a973-9463e639200f",
        "storage_key": "property/6767906449167135/019d270f-06c0-73ee-a973-9463e639200f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Atrium Court | Gym",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yaHopXPwT6A"
    },
    {
      "id": "custom_a0b2ebd7-d3b6-4d55-af3e-7bb6c728f7fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-06df-75fe-a25c-f44c9a5ccc60.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with wooden cabinets and granite countertops, view into living room.",
        "public_id": "019d270f-06df-75fe-a25c-f44c9a5ccc60",
        "storage_key": "property/6767906449167135/019d270f-06df-75fe-a25c-f44c9a5ccc60.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Atrium Court | 1A | 1 BR, 1 BA - 664SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hX96iP14kpS"
    },
    {
      "id": "custom_82b06700-a8b4-4f22-8ff7-e8a9a62ba942",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167135/019d270f-06c1-751a-8090-963d9b42c5d3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with wood cabinets, black appliances, and a double sink.",
        "public_id": "019d270f-06c1-751a-8090-963d9b42c5d3",
        "storage_key": "property/6767906449167135/019d270f-06c1-751a-8090-963d9b42c5d3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Atrium Court | 2A | 2 BR, 2 BA - 879SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mvD476jR9zj"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e23be-8dfe-722f-b8ca-9a1dcabd1aaa",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Atrium Court Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135"
    },
    {
      "lead_collector_id": "019e23be-8e6f-760b-a545-1c1cff86bbbe",
      "lead_source": "LANDING_PAGE",
      "name": "Atrium Court Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-north-mountain",
      "search_query": "pet friendly apartments North Mountain Village",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments at Atrium Court",
      "h2_subtitle": "Discover pet-friendly living in North Mountain Village. Atrium Court offers a welcoming environment for you and your furry friends.",
      "page_copy": "Welcome to Atrium Court, where you and your furry companions can find a home in the vibrant North Mountain Village. Our pet-friendly apartments are designed to accommodate the needs of both you and your pets, providing a smoke-free community with plenty of green spaces nearby for walking and playing. Enjoy the convenience of our dedicated and friendly leasing team eager to help with any of your questions or service requests.\n\nOur apartments feature modern amenities such as microwaves and window coverings to make your living experience comfortable and enjoyable. Atrium Court is committed to ensuring you and your pets feel right at home. Settle into a community that embraces pet-friendly living while situated in the heart of North Mountain Village, ensuring that everything you need is just a short walk or drive away. The entire community welcomes both you and your pets with open arms.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in North Mountain Village",
      "seo_description": "Find pet-friendly living at Atrium Court in North Mountain Village. Enjoy comfortable apartments and a welcoming community!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "luxury-pool-apartments-phoenix-az",
      "search_query": "luxury pool apartments in Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Luxury Pool Apartments at Atrium Court",
      "h2_subtitle": "Experience upscale living with a luxury pool in Phoenix, AZ. Atrium Court offers premium amenities in a vibrant community.",
      "page_copy": "Elevate your lifestyle at Atrium Court, where luxury meets convenience in the heart of Phoenix, AZ. Our apartments feature access to a stunning pool area, providing a perfect oasis for relaxation and leisure. Located in the serene North Mountain Village, Atrium Court presents an unparalleled living experience with sophisticated amenities and a dedicated leasing team always ready to assist.\n\nOur community offers modern conveniences like microwaves and window coverings, all within a smoke-free environment. Engage with our vibrant community and take advantage of online service requests, ensuring easy living. Located amid the lively Phoenix area, you'll have quick access to all the city has to offer, from dining and shopping to outdoor adventures, all enhanced by the luxury pool that serves as the centerpiece of relaxation and social gatherings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Pool Apartments in Phoenix, AZ",
      "seo_description": "Atrium Court offers luxury pool apartment living in Phoenix, AZ. Experience upscale amenities and a vibrant community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "washer-dryer-in-unit-apartments-maricopa-county",
      "search_query": "washer dryer in unit apartments Maricopa County",
      "category": "Amenity",
      "h1_title": "Apartments with Washer & Dryer in Maricopa",
      "h2_subtitle": "Discover the convenience of in-unit washer and dryer at Atrium Court, located in Maricopa County's vibrant North Mountain Village.",
      "page_copy": "Welcome to Atrium Court, where convenience meets modern living in Maricopa County. Our apartments are equipped with an in-unit washer and dryer, providing you with the ultimate convenience in a stunning environment. Nestled in North Mountain Village, our community offers a smoke-free lifestyle enriched with numerous amenities.\n\nEnjoy the support of our friendly leasing team and the ease of online service requests, making day-to-day living seamless. Your modern kitchen includes a handy microwave, while the window coverings add a touch of style and functionality. Reside in the heart of Maricopa County, with everything from shopping and dining to outdoor activities just moments away, all while enjoying the added convenience of having a washer and dryer right in your apartment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer & Dryer in Maricopa County",
      "seo_description": "Find apartments with in-unit washers and dryers at Atrium Court in Maricopa County. Enjoy the convenience and modern lifestyle today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "apartment-with-air-conditioning-85021",
      "search_query": "apartment with air conditioning 85021",
      "category": "Amenity",
      "h1_title": "Cool Apartments with Air Conditioning",
      "h2_subtitle": "Stay comfortable with air-conditioned apartments at Atrium Court, located in the 85021 area of Phoenix, AZ.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Atrium Court, situated in the 85021 zip code of Phoenix, AZ. Our apartments come equipped with air conditioning, ensuring you stay cool and comfortable year-round in the warm Arizona climate. Located in the thriving North Mountain Village, you'll enjoy a smoke-free community designed with modern living in mind.\n\nOur dedicated leasing team is available to assist you, while online service requests make managing your home life easy. Enjoy modern amenities including a microwave and stylish window coverings, enhancing your living experience. Nestled in a prime location with easy access to dining, shopping, and outdoor adventures, Atrium Court combines the comfort of air-conditioned apartments with the joys of vibrant city living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Phoenix, AZ 85021",
      "seo_description": "Find cool, air-conditioned apartments at Atrium Court in Phoenix, AZ 85021. Enjoy comfort and modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-phoenix-az",
      "search_query": "apartments with fitness center Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Phoenix, AZ",
      "h2_subtitle": "Discover apartments with a fitness center at Atrium Court in Phoenix, AZ. Achieve your fitness goals right at home.",
      "page_copy": "Atrium Court offers a lifestyle of health and wellness right at your doorstep in Phoenix, AZ. Our community features a state-of-the-art fitness center, perfect for maintaining your healthy lifestyle without the need for a gym membership. Located in the scenic North Mountain Village, Atrium Court combines exceptional amenities with the convenience of a city-centric location.\n\nOur modern apartments come with convenient features such as microwaves and window coverings, set within a smoke-free community. With the support of a friendly leasing team and the ease of online service requests, taking care of your living space is effortless. Embrace a balanced life in our fitness-equipped community while enjoying easy access to Phoenix's vibrant cultural, dining, and recreational opportunities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Phoenix, AZ",
      "seo_description": "Find apartments with a fitness center at Atrium Court in Phoenix, AZ. Enjoy modern amenities and active living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-phoenix-az",
      "search_query": "one bedroom apartments phoenix az",
      "category": "Floorplan",
      "h1_title": "Spacious One-Bedroom Apartments in Phoenix",
      "h2_subtitle": "Explore one-bedroom apartments at Atrium Court in Phoenix, AZ. Enjoy modern amenities and a vibrant community in a prime location.",
      "page_copy": "Welcome to Atrium Court, where chic city living meets comfort in our spacious one-bedroom apartments located in Phoenix, AZ. Each apartment is thoughtfully designed with modern amenities, including air conditioning, a microwave for easy meal preps, and stylish window coverings. Our smoke-free community offers a peaceful retreat, nestled in the vibrant North Mountain Village neighborhood.\n\nEnjoy the convenience of a friendly leasing team ready to assist you with any needs, along with the simplicity of online service requests. At Atrium Court, you'll have everything you need for a comfortable living experience, with easy access to Phoenix's bustling dining, shopping, and entertainment scenes. Make your next move to a one-bedroom apartment that offers both convenience and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Phoenix, AZ",
      "seo_description": "Discover one-bedroom apartments at Atrium Court in Phoenix, AZ. Enjoy modern living with convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167135",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-north-mountain-village",
      "search_query": "two bedroom apartments near north mountain village",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments Near North Mountain",
      "h2_subtitle": "Find spacious two-bedroom apartments near North Mountain Village at Atrium Court. Enjoy modern living in a prime location.",
      "page_copy": "Discover the perfect home for you at Atrium Court, offering elegant two-bedroom apartments near the beautiful North Mountain Village in Phoenix. Our spacious layouts are ideal for those seeking extra room and modern comforts like air conditioning and energy-efficient appliances, including a microwave. Each apartment features stylish window coverings, helping create a warm and inviting atmosphere.\n\nOur community is smoke-free and benefits from a convenient location with easy access to shopping, dining, and outdoor recreation. Managed by a friendly leasing team and equipped with online service request capabilities, living at Atrium Court is hassle-free. Embrace the comfort of a two-bedroom apartment designed for modern living in a vibrant neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments Near North Mountain",
      "seo_description": "Explore spacious two-bedroom apartments at Atrium Court near North Mountain Village. Enjoy modern amenities in a prime Phoenix location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308890816"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=5202658013"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WZVJL7P4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "70440144-d20a-40c8-afec-ae9b6dc142b1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7d5cfe5b-e60b-4307-9738-e9b8f76d58a4/app.js?property=7d5cfe5b-e60b-4307-9738-e9b8f76d58a4&propertyName=Atrium+Court&channelUuid=c2490a52-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47723982652"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlhmMk15aU9DQ3dyKzZORjFXNTdsV1E9PSIsInZhbHVlIjoiS24zdFh0TithdU9lM3NnY3VSM1FWZz09IiwibWFjIjoiZGYzY2RkOTBjM2EyNTQxNzlmZGJhMTE5ZWVmMzZhYWI3OWRjYjIyZDU1MmJlNjM1ZmExODNkOTdhMWU0YmYyYyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308890816",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=5202658013",
  "custom_google_gtm_id": "GTM-WZVJL7P4",
  "custom_rollout_phase": "Phase 3",
  "custom_rentgrata_token": "70440144-d20a-40c8-afec-ae9b6dc142b1",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7d5cfe5b-e60b-4307-9738-e9b8f76d58a4/app.js?property=7d5cfe5b-e60b-4307-9738-e9b8f76d58a4&propertyName=Atrium+Court&channelUuid=c2490a52-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47723982652",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlhmMk15aU9DQ3dyKzZORjFXNTdsV1E9PSIsInZhbHVlIjoiS24zdFh0TithdU9lM3NnY3VSM1FWZz09IiwibWFjIjoiZGYzY2RkOTBjM2EyNTQxNzlmZGJhMTE5ZWVmMzZhYWI3OWRjYjIyZDU1MmJlNjM1ZmExODNkOTdhMWU0YmYyYyJ9",
  "custom_audioeye_site_id": "cd2a5dae-09d9-45d3-bedc-9bc6d0b5c6a6",
  "custom_audioeye_site_hash": "e9c43001e80c762880517cd30c74d3d0"
};

export const generatedAt = '2026-10-27T17:11:44.414Z';
